import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import './assets/style.css';
import { Breadcrumbs } from '../../components/Atom/breadcumbs';
import { Skeleton, Empty, Table } from 'antd';
import { getRules } from 'api/routingRules';
import { TIMEZONES } from 'utils/constant';
import { convertToStoreTimezone } from 'utils/services';
import { ArrowLeftOutlined } from '@ant-design/icons';
import ShortenId from 'components/Atom/ShortenId';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
export const ViewRuleDetails = () => {
  const location = useLocation();
  const store = useSelector((state) => state?.company?.store);
  const { id } = useParams();
  const [record, setRecord] = useState(location?.state?.record);
  const [isLoading, setIsLoading] = useState(false);
  const capitalizeFirstLetter = (string) => {
    return string?.charAt(0)?.toUpperCase() + string?.slice(1);
  };
  const fetchData = async () => {
    if (!location?.state?.record?._id) {
      setIsLoading(true);
      const params = { store_id: location?.state?.record?.store_id, search: location?.state?.record?._id };
      const response = await getRules(params);
      const result = await convertToStoreTimezone(response, store?.settings?.timezone || TIMEZONES?.PKT);
      setRecord(result[0] || null);
      setIsLoading(false);
    }
  };
  useEffect(() => {
    fetchData();
  }, []);
  const breadcrumbProps = {
    breadcrumbs: [
      {
        name: 'XPay',
        href: '/xpay',
      },
      {
        name: 'Payment Routing',
        href: '/payment-routing',
      },
      {
        name: <ShortenId value={id || location?.state?.record?._id || 'Not Found'} />,
      },
    ],
  };

  const formatGatewayType = (type) => {
    if (!type) return 'N/A';
    return type
      ?.split('-')
      ?.map((part) => part?.charAt(0)?.toUpperCase() + part?.slice(1))
      ?.join(' ');
  };

  const failureGatewayRows =
    record?.failure_gateways?.length > 0
      ? record?.failure_gateways?.map((gateway, index) => ({
          id: record?.on_failure_instance_id?.[index] || gateway?.id,
          name: gateway?.name,
          type: gateway?.type,
        }))
      : (record?.on_failure_instance_id || [])?.map((instanceId) => ({
          id: instanceId,
          name: 'N/A',
          type: null,
        }));

  const gatewayColumns = [
    {
      title: 'Gateway ID',
      render: (value) => value?.id || 'N/A',
      key: 'id',
      width: '33.33%',
    },
    {
      title: 'Name',
      render: (value) => value?.name || 'N/A',
      key: 'name',
      width: '33.33%',
    },
    {
      title: 'Gateway Type',
      render: (value) => formatGatewayType(value?.type),
      key: 'type',
      width: '33.33%',
    },
  ];

  const gatewayRow = [
    {
      id: record?.instance_id,
      name: record?.current_gateway?.name,
      type: record?.current_gateway?.type,
    },
  ];

  const generalInformation = [
    { label: 'Rule ID', value: record?._id },
    { label: 'Name', value: record?.name },
    { label: 'Retry Strategy', value: capitalizeFirstLetter(record?.payment_retry_strategy) },
    { label: 'Active', value: record?.enabled === true ? 'Yes' : 'No' },
    { label: 'Creation Time', value: record?.createdAt },
    { label: 'Last Update Time', value: record?.updatedAt },
  ];
  return (
    <>
      <div className='header-container p-4 custom-sticky'>
        <div className='transaction-breadcrums' style={{ display: 'flex', gap: '16px', marginBottom: '15px', alignItems: 'center' }}>
          <div className='back-button' onClick={() => window?.history?.back()}>
            <ArrowLeftOutlined /> <span style={{ fontWeight: 600 }}>Back</span>
          </div>
          <span style={{ color: '#8C8C8C' }}>|</span>
          <Breadcrumbs {...breadcrumbProps} />
        </div>
        <div className='detail-heading mt-4'>Payment Routing Detail</div>
      </div>
      <div className='subscription-details'>
        {isLoading ? (
          <div style={{ width: '100%' }}>
            <Skeleton active />
          </div>
        ) : !record ? (
          <div className='empty-custom-style'>
            <Empty image={Empty?.PRESENTED_IMAGE_SIMPLE} />
          </div>
        ) : (
          <>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Rule Details</h3>
              </div>
              <div className='detail-card'>
                {generalInformation?.map((info, index) => (
                  <div key={index} className='detail-value'>
                    <h2>{info?.label}</h2> <span>{info?.value || 'N/A'}</span>
                  </div>
                ))}
              </div>
            </div>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Primary Gateway</h3>
              </div>
              <div className='table-container gateway-equal-table'>
                <Table columns={gatewayColumns} dataSource={gatewayRow} pagination={false} rowKey='id' tableLayout='fixed' />
              </div>
              <div className='heading-section'>
                <h3>Failure Gateways</h3>
              </div>
              <div className='table-container gateway-equal-table'>
                {failureGatewayRows.length > 0 ? (
                  <Table columns={gatewayColumns} dataSource={failureGatewayRows} pagination={false} rowKey={(row, index) => row?.id || index} tableLayout='fixed' />
                ) : (
                  <div className='empty-details'>
                    <div>No Failure Gateways</div>
                  </div>
                )}
              </div>
            </div>
            <div className='details-section '>
              <div className='heading-section'>
                <h3>Rule Conditions</h3>
              </div>
              <div className='detail-card'>
                {record?.amount ? (
                  <>
                    <div className='detail-value'>
                      <h2>Amount Condition</h2> <span>{capitalizeFirstLetter(record?.amount?.operator)}</span>
                    </div>
                    <div className='detail-value'>
                      <h2>Amount {record?.amount?.operator == 'range' ? 'Range' : 'Value'}</h2>
                      <span>{record?.amount?.operator == 'range' ? record?.amount?.rangeFrom + ' to ' + record?.amount?.rangeTo : record?.amount?.value}</span>
                    </div>
                  </>
                ) : (
                  <div className='detail-value'>
                    <h2>Amount</h2> <span>All</span>
                  </div>
                )}
                <div className='detail-value'>
                  <h2>{record?.currency?.length === 1 ? 'Currency' : 'Currencies'}</h2>
                  <span>{record?.currency?.length > 0 ? record?.currency?.map((location) => location?.toUpperCase())?.join(', ') : 'All'}</span>
                </div>
                <div className='detail-value'>
                  <h2>
                    {record?.location?.length === 1 ? 'Location' : 'Locations'}
                    {record?.location?.length && (
                      <span className='py-[1px] text-[#000000d9] text-[12px] ml-1 border border-[#d9d9d9] rounded-md shadow-sm bg-[#fafafa] px-2'>
                        {record?.is_location_excluded ? 'Excludes' : 'Includes'}
                      </span>
                    )}
                  </h2>{' '}
                  <span>{record?.location?.length > 0 ? record?.location?.map(capitalizeFirstLetter)?.join(', ') : 'All'}</span>
                </div>
                <div className='detail-value'>
                  <h2>{record?.bins?.length === 1 ? 'Bin' : 'Bins'}</h2> <span>{record?.bins?.length > 0 ? record?.bins?.map((value) => value)?.join(', ') : 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>{record?.attributes?.length === 1 ? 'Attribute' : 'Attributes'}</h2> <span>{record?.attributes?.length > 0 ? record?.attributes?.map((value) => value)?.join(', ') : 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Exchange Rate Amount</h2>
                  <span>
                    {record?.exchange_rate?.amount
                      ? `${record?.exchange_rate?.amount} ${
                          record?.exchange_rate?.is_payment_base_conversion ? record?.exchange_rate?.payment_currency?.toUpperCase() : record?.exchange_rate?.order_currency?.toUpperCase()
                        }`
                      : 'N/A'}
                  </span>
                </div>
                <div className='detail-value'>
                  <h2>Order Currency</h2>
                  <span>{record?.exchange_rate?.order_currency?.toUpperCase() || 'N/A'}</span>
                </div>
                <div className='detail-value'>
                  <h2>Payment Currency</h2>
                  <span>{record?.exchange_rate?.payment_currency?.toUpperCase() || 'N/A'}</span>
                </div>
              </div>
            </div>
          </>
        )}
      </div>
    </>
  );
};
